<template>
  <modal width="30" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div>
      <b>Cash Payment</b>
      <div class="flex flex-row pt-4">
        <span class="mr-2 w-10 h-10 rounded-[50px] overflow-hidden mt-1">
          <img src="@/assets/images/icons/paymenticon.svg" />
        </span>
        <div>
          <span class="capitalize opacity-50 text-base font-[600] block w-full">PAYMENT DUE</span>
          <b class="text-base block w-full py-1">₦{{ amountFomatter(costEngine.cost || costEngine.totalCost ||
            costEngine.totalValue) }}</b>
        </div>
      </div>

      <button @click="updateTransactionStatus"
        class="font-semibold bg-primary-yellow mt-4 w-full trext-center py-2 rounded">
        Continue
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    transactionId: {
      type: String
    },
    costEngine: {
      type: Object
    },
    tipInfo: {
      type: Object
    },
    paymentMethod: {}
  },
  computed: {
    downpayment() {
      let percent = (this.costEngine?.cost || this.costEngine?.totalCost) * 0.1
      return this.amountFomatter(percent)
    }
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
    async createlastmileDispatch() {
      // this.loading = true;
      try {
        if (!this.$store.getters?.getselectedBroadcastDriver?.id) {
          this.$store.dispatch('setSavedActiveTab', 4);
          return;
        }
        const payload = this.$store.getters.getThirdPartySelectedDispatch;
        await this.$_greateLastMileDispatch(payload);
        this.$store.dispatch('setSavedActiveTab', 4)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false;
      }
    },
    async updateTransactionStatus() {
      try {
        await this.$_updateUserTransaction(this.transactionId, {
          transactionReference: null,
          payment_type: this.paymentMethod,
          type: this.paymentMethod,
          tip: Number(this.tipInfo?.tip),
          tipAmount: this.tipInfo?.tipAmount,
        })
        this.createlastmileDispatch()
      } catch (error) {
        this.handleError(error)
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>

<style scoped>
.opaq-bg {
  background: rgba(252, 194, 16, 0.15);
  @apply border-primary-yellow
}
</style>